import { KINDRED_SUPPORT_EMAIL } from "./legalLinks";

export const AUTH_SUPPORT_SUCCESS_MESSAGE =
  "Your request has reached the Kindred admin team. We will reply to the email address you provided.";

export const buildAuthSupportMailto = (email?: string | null) => {
  const subject = encodeURIComponent("Help signing in to Kindred");
  const body = encodeURIComponent(
    [
      "Hello Kindred support,",
      "",
      "I am having trouble signing in.",
      email?.trim() ? `My Kindred email is: ${email.trim()}` : "My Kindred email is:",
      "",
      "What happens when I try:",
      "",
    ].join("\n"),
  );

  return `mailto:${KINDRED_SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
};

export const validateAuthSupportRequest = ({
  email,
  issue,
}: {
  email: string;
  issue: string;
}) => {
  const errors: { email?: string; issue?: string } = {};
  const normalizedEmail = email.trim().toLowerCase();
  const normalizedIssue = issue.trim();

  if (!normalizedEmail) {
    errors.email = "Please enter the email address you use for Kindred.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) {
    errors.email = "That email address does not look valid.";
  }

  if (normalizedIssue.length < 3) {
    errors.issue = "Please tell us what happens when you try to sign in.";
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
    email: normalizedEmail,
    issue: normalizedIssue.slice(0, 2000),
  };
};
